<template>
  <div>
    <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-hidden="true" :class="{'show d-block': isModalOpen}" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{action === 'create' ? $t('add_bank_account') : $t('edit_bank_account')}}</h5>
            <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submit">
              <div class="mb-3">
                <label class="form-label">{{$t('account_name')}} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.account_name" required>
              </div>

              <div class="mb-3">
                <label class="form-label">{{$t('bank_name')}} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.bank_name" required>
              </div>

              <div class="mb-3">
                <label class="form-label">{{$t('account_number')}} <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="form.account_number" required>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">{{$t('iban')}}</label>
                  <input type="text" class="form-control" v-model="form.iban">
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">{{$t('swift_code')}}</label>
                  <input type="text" class="form-control" v-model="form.swift_code">
                </div>
              </div>

              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">{{$t('currency')}}</label>
                  <input type="text" class="form-control" v-model="form.currency" readonly>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">{{$t('balance')}}</label>
                  <input type="number" step="0.01" class="form-control" v-model="form.balance">
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">{{$t('status')}}</label>
                <select class="form-select" v-model="form.status">
                  <option value="active">{{$t('active')}}</option>
                  <option value="inactive">{{$t('inactive')}}</option>
                </select>
              </div>

              <div class="mb-3">
                <collapsible-notes-field v-model="form.notes" id="bank-account-notes" rows="3" />
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeModal">{{$t('cancel')}}</button>
                <button type="submit" class="btn btn-success" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{action === 'create' ? $t('create') : $t('update')}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from '../../helper'

export default {
  name: 'AddEditBankAccountModal',
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },
    modalId: {
      type: String,
      default: 'bank-account-modal'
    },
    data: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      form: {
        account_name: '',
        bank_name: '',
        account_number: '',
        iban: '',
        swift_code: '',
        currency: this.$store.state.business?.currency || 'USD',
        balance: 0,
        status: 'active',
        notes: ''
      },
      loading: false
    }
  },
  mounted() {
    if (this.data && this.action === 'edit') {
      this.form = {
        account_name: this.data.account_name,
        bank_name: this.data.bank_name,
        account_number: this.data.account_number,
        iban: this.data.iban || '',
        swift_code: this.data.swift_code || '',
        currency: this.data.currency || this.$store.state.business?.currency || 'USD',
        balance: this.data.balance || 0,
        status: this.data.status || 'active',
        notes: this.data.notes || ''
      }
    } else {
      // Set currency from business for new accounts
      this.form.currency = this.$store.state.business?.currency || 'USD'
    }
  },
  methods: {
    async submit() {
      try {
        this.loading = true
        
        if (this.action === 'create') {
          await helper.customPost(`${process.env.VUE_APP_API}/bank-accounts`, this.form, {showToast: true})
        } else {
          await helper.customPatch(`${process.env.VUE_APP_API}/bank-accounts/${this.data.id}`, this.form, {showToast: true})
        }
        
        this.loading = false
        this.$emit('refresh')
        this.closeModal()
      } catch (error) {
        this.loading = false
        alert(error)
      }
    },
    closeModal() {
      this.$emit('modalClosed')
    }
  }
}
</script>

<style scoped>
.modal.show {
  display: block;
}
</style>
